<template lang="pug">
  WtEntityTable.admin-challenge-table(
    :title="`${_.capitalize(status)} Challenges`"
    :data="_.get(challengesData, 'data', [])"
    :default-sort-field="defaultSortField"
    :empty-message="`There are no ${status} challenges.`"
    :showEmptyMessage="!loading"
    :loading="loading"
  )
    BTableColumn(
      field="name"
      label="Challenge Name"
      sortable
      v-slot="column"
    )
      .columns
        .column
          BTooltip(
            label="View this challenge"
            position="is-top"
            animated
          )
            WtRouterLink(
              to="Challenge"
              :params="{ challengeId: column.row.id.toString() }"
              type="table"
              :text="column.row.name"
            )
        .column.is-1
          WtRouterLink(
            v-if="showChallengeEditButton(column.row)"
            to="ChallengeEditAdmin"
            :params="{ challengeId: column.row.id.toString() }"
            type="table"
          )
            BIcon(slot="icon" icon="settings" size="is-small")
    BTableColumn(
      field="collateral"
      label="Collateral"
      v-slot="column"
    )
      BTooltip(
        :label="_.get(column.row, 'map.poster', false) || _.get(column.row, 'map.emailTemplate', false) ? 'download' : 'nothing to download'"
        position="is-right"
      )
        BDropdown(
          :disabled="!_.get(column.row, 'map.poster', false) && !_.get(column.row, 'map.emailTemplate', false)"
          hoverable
        )
          BIcon(slot="trigger" icon="download" @click.native="collateralModalOpen = true;")
          BDropdownItem(v-if="_.get(column.row, 'map.poster', false)")
            a(:href="column.row.map.poster" download) Poster
          BDropdownItem(v-if="_.get(column.row, 'map.emailTemplate', false)")
            a(:href="column.row.map.emailTemplate" download) Email Template
    BTableColumn(
      field="between"
      label="Type"
      sortable
      v-slot="column"
    )
      | {{ challengeType(column.row) }}
    BTableColumn(
      field="public"
      label="Public"
      sortable
      v-slot="column"
    )
      | {{ publicText(column.row.public) }}
    BTableColumn(
      field="initiator.isAdmin"
      label="Created By"
      sortable
      v-slot="column"
    )
      | {{ adminOrMember(column.row.initiator.isAdmin) }}
    BTableColumn(
      field="startDate"
      label="Start Date"
      sortable
      v-slot="column"
    )
      | {{ date(column.row.startDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(
      field="endDate"
      label="End Date"
      sortable
      v-slot="column"
    )
      | {{ date(column.row.endDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(
      v-if="showAction"
      label="Action"
      v-slot="column"
    )
      WtButton(
        is-text
        @click.native="deleteChallenge(column.row)"
      )
        BIcon(icon="delete")
</template>

<script>
import { mapActions } from "vuex";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";

export default {
  name: "AdminChallengeTable",

  components: { WtEntityTable, WtButton, WtRouterLink },

  mixins: [dateUtilityMixin, challengeMixin],

  props: {
    challengesData: {
      type: Object,
      default: () => {}
    },

    // active, pending, archived
    status: {
      type: String,
      default: ""
    },

    deleteAction: {
      type: Function,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    },

    defaultSortField: {
      type: String,
      default: "name"
    }
  },

  data() {
    return {
      collateralModalOpen: false
    };
  },

  computed: {
    showAction() {
      return this.status === "archived";
    }
  },

  methods: {
    ...mapActions(["snackBar"]),

    adminOrMember(isAdmin) {
      return isAdmin ? "Admin" : "Member";
    },

    publicText(boolean) {
      return boolean ? "Yes" : "No";
    },

    deleteChallenge(challenge) {
      const name = challenge.name;

      this.$buefy.dialog.confirm({
        title: `Deleting Challenge`,
        confirmText: "Delete Challenge",
        type: "is-danger",
        hasIcon: true,
        message: `Are you sure you want to delete ${name}? This cannot be undone.`,
        onConfirm: () => {
          this.deleteAction(challenge.id).then(response => {
            if (response && response.data.success) {
              this.snackBar({
                type: "is-success",
                message: `${name} has been deleted.`
              });
            }
          });
        }
      });
    },

    showChallengeEditButton(challenge) {
      if (challenge.isPvsPChallenge) return false;

      return true;
    }
  }
};
</script>

<style lang="sass" scoped>
.admin-challenge-table
  .padding-right
    padding-right: 15px
</style>
